<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="advertiser">
      <!-- 媒体商信息查询条件区域 -->
      <div class="filter-search">
        <el-form
          label-position="right"
          :inline="true"
          label-width="100px"
          :model="searchData"
          ref="searchForm"
        >
          <el-form-item label="广告主ID：">
            <el-autocomplete
              clearable
              v-model="searchData.UserId"
              :fetch-suggestions="getUser"
              @select="handleSelect"
              :maxlength="9"
              placeholder="请输入广告主ID"
            >
              <!-- <i class="el-icon-edit el-input__icon" slot="suffix">
              </i> -->
              <template slot-scope="{ item }">
                <el-row :gutter="24">
                  <el-col
                    :span="8"
                    v-if="item.id"
                  ><span>[{{ item.id }}]</span></el-col>
                  <el-col :span="16"><span style="display:inline-block;width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</span></el-col>
                </el-row>
              </template>
            </el-autocomplete>
            <!-- <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model="searchData.UserId" clearable placeholder="请输入广告主ID"></el-input> -->
          </el-form-item>
          <el-form-item
            label="公司名称："
            prop="CompanyName"
          >
            <el-input
              type="text"
              size="small"
              v-model="searchData.CompanyName"
              clearable
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="EMail："
            prop="UserEmail"
          >
            <el-input
              type="text"
              size="small"
              v-model="searchData.UserEmail"
              clearable
              placeholder="请输入email"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="资料完整度："
            prop="Complete"
          >
            <el-select
              size="small"
              v-model="searchData.Complete"
              placeholder="资料完整度"
            >
              <el-option
                label="全部"
                value="0"
              ></el-option>
              <el-option
                label="20%以下"
                value="0.2"
              ></el-option>
              <el-option
                label="40%以下"
                value="0.4"
              ></el-option>
              <el-option
                label="60%以下"
                value="0.6"
              ></el-option>
              <el-option
                label="80%以下"
                value="0.8"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="审核状态："
            prop="Status"
          >
            <el-select
              size="small"
              v-model="searchData.Status"
              placeholder="审核状态"
            >
              <el-option
                label="全部"
                value="-1"
              ></el-option>
              <el-option
                label="未上传"
                value="0"
              ></el-option>
              <el-option
                label="待通过"
                value="1"
              ></el-option>
              <el-option
                label="已拒绝"
                value="2"
              ></el-option>
              <el-option
                label="已通过"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="广告运营："
            prop="AdOperatorName"
          >
            <el-select
              size="small"
              v-model="searchData.AdOperatorName"
              placeholder="广告运营"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <template v-for="item in  UserAdOperatorUser">
                <el-option
                  :label="item.name"
                  :value="item.name"
                  :key="item.id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="销售："
            prop="SalesmanName"
          >
            <el-select
              size="small"
              v-model="searchData.SalesmanName"
              placeholder="销售"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <template v-for="item in  Salesman">
                <el-option
                  :label="item.name"
                  :value="item.name"
                  :key="item.UserId"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="广告主身份："
            prop="UserSource"
          >
            <el-select
              size="small"
              v-model="searchData.UserSource"
              placeholder="请选择广告主身份"
            >
              <el-option
                label="全部"
                value="-1"
              ></el-option>
              <el-option
                label="代理商"
                value="1"
              ></el-option>
              <el-option
                label="子账户"
                value="2"
              ></el-option>
              <el-option
                label="直客"
                value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="邮箱激活状态："
            prop="IsActive"
          >
            <el-select
              size="small"
              v-model="searchData.IsActive"
              placeholder="邮箱激活状态"
            >
              <el-option
                label="全部"
                value="0"
              ></el-option>
              <el-option
                label="已激活"
                value="1"
              ></el-option>
              <el-option
                label="未激活"
                value="-1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属代理："
            prop="proxyID"
          >
            <el-input
              type="text"
              size="small"
              v-model="searchData.proxyID"
              clearable
              placeholder="请输入ID／公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="添加时间："
            prop="applyTime"
          >
            <el-date-picker
              size="small"
              v-model="searchData.applyTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button
              type="primary"
              size="small"
              @click="getAdvertiserList(1)"
            >搜索</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="!UserRoleList.Edit? true : false"
              @click="goOtherPage(0)"
            >添加广告主</el-button>
            <a
              class="export-button"
              :href="exportUrl"
            >导出</a>
          </el-form-item>
        </el-form>
      </div>
      <!-- 审核数据类型选择区域 -->
      <div class="data-type">
        <span class="iconfont el-icon-touxiang data-size"> 客户基本信息（共 {{dataSize}} 条）</span>
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <el-table
          :data="tableData"
          stripe
          @cell-mouse-enter="setToolTip"
          header-row-class-name="table-header-style"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            fixed="left"
            label="操作"
            width="160"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="10">
                  <el-button
                    :disabled="!UserRoleList.Edit? true : false"
                    @click="goOtherPage(scope.row)"
                    icon="el-icon-edit"
                    type="text"
                    size="small"
                  >编辑
                  </el-button>
                </el-col>
                <el-col :span="14">
                  <a
                    :disabled="!UserRoleList.Edit? true : false"
                    v-if="scope.row.UserSourceStr === '代理商'"
                    class="goOtherPage el-icon-circle-plus-outline"
                    :href="`/iad_customer/addsonuser?PId=${scope.row.UserId}`"
                    target="_blank"
                  >
                    添加账户</a>
                  <a
                    :disabled="!UserRoleList.Edit? true : false"
                    v-else
                    class="goOtherPage el-icon-circle-plus-outline"
                    :href="`/iad_adsmanage/list?BAdrId=${scope.row.UserId}`"
                    target="_blank"
                  >
                    添加广告</a>
                </el-col>
                <el-col :span="10">
                  <el-button
                    @click="recharge(scope.row)"
                    :disabled="!UserRoleList.List? true : false"
                    v-if="scope.row.UserSourceStr != '子账户'"
                    class="iconfont el-icon-jine"
                    type="text"
                    size="small"
                  > 充值
                  </el-button>
                </el-col>
                <el-col :span="14">
                  <el-button
                    @click="refund(scope.row)"
                    v-if="scope.row.UserSourceStr != '子账户'"
                    class="iconfont el-icon-tuikuan"
                    type="text"
                    size="small"
                  > 退款
                  </el-button>
                </el-col>
              </el-row>

            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="审核操作"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="auditing(scope.row, 1)"
                :disabled="(scope.row.Status != 1) & (scope.row.Status != 0) || !UserRoleList.CheckUser? true : false"
                type="text"
                size="small"
              >通过
              </el-button>
              <el-button
                @click="auditing(scope.row, 0)"
                :disabled="(scope.row.Status != 1) & (scope.row.Status != 0) || !UserRoleList.CheckUser? true : false"
                type="text"
                size="small"
              >拒绝
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="StatusStr"
            label="审核状态"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="UserSourceStr"
            label="广告主身份"
            min-width="110"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="UserId"
            label="广告主ID"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="CompanyName"
            label="公司名称"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="ParentUserName"
            label="所属代理"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="AdOperatorName"
            label="广告运营"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="UserEmail"
            label="邮箱"
            min-width="230"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="SalesmanName"
            label="销售"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            class-name="showToolTip"
            show-overflow-tooltip
            prop="AccumulatedAmount"
            label="累计金额"
            min-width="130"
          >
            <template slot-scope="scope">
              <span>{{scope.row.AccumulatedAmount | tofixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="AdsBalance"
            label="可用金额"
            min-width="130"
          >
            <template slot-scope="scope">
              <span>{{scope.row.AdsBalance | tofixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="IsActiveStr"
            label="邮箱激活状态"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="formatDater"
            prop="AddDate"
            label="添加时间"
            min-width="110"
          >
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="formatDater"
            prop="UpdateDate"
            label="修改时间"
            width="110"
          >
          </el-table-column>
        </el-table>
        <!-- 分页设置 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="dataSize"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 审核弹层设置 -->

    <refundDialog
      v-if="showRefundDialog"
      @close="closeRefundDialog"
      :refundInfo="refundInfo"
    ></refundDialog>
    <rechargeDialog
      v-if="showRechargeDialog"
      @close="closeRechargeDialog"
      :rechargeInfo="currentData"
    ></rechargeDialog>

  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// 充值和退款弹层
import rechargeDialog from "../public/customer-management/recharge-dialog";
import refundDialog from "../public/customer-management/refund-dialog";
// 格式化时间
import { formatDateAll } from "common/js/common";
// api
import {
  GetAdvertiserList,
  CheckUser,
  IadAdrRecharge,
  RefundShowSubmit,
  GetSalesman,
  GetUserAdOperatorUser,
  GetUser,
  RefundShow,
  GetUserRoleList
} from "api/advertiser";
import { StatusInfo } from "api/retStatus";

export default {
  data() {
    return {
      // 搜索条件
      searchData: {
        Complete: "0",
        IsActive: "0",
        UserId: "",
        UserEmail: "",
        SalesmanName: "",
        CompanyName: "",
        Status: "-1",
        UserSource: "-1",
        AdOperatorName: "",
        applyTime: "",
        // 所属代理
        proxyID: ""
      },
      // 面包屑
      trails: [
        {
          trail: "客户管理",
          href: ""
        },
        {
          trail: "广告主客户",
          href: ""
        }
      ],
      showRefundDialog: false,
      showRechargeDialog: false,
      // 列表长度
      dataSize: 0,
      // 退款信息
      refundInfo: "",
      // 表格数据
      tableData: [],
      // 分页当前页
      currentPage: 1,
      // 分页每页条数
      pageSize: 20,
      currentData: {},
      Salesman: [],
      UserAdOperatorUser: [],
      UserRoleList: {}
    };
  },
  computed: {
    // 导出数据路径和参数
    exportUrl() {
      var filterData = {
        Complete: this.searchData.Complete,
        IsActive: this.searchData.IsActive,
        UserId: this.searchData.UserId,
        UserEmail: this.searchData.UserEmail,
        SalesmanName: this.searchData.SalesmanName,
        CompanyName: this.searchData.CompanyName,
        Status: this.searchData.Status,
        UserSource: this.searchData.UserSource,
        AdOperatorName: this.searchData.AdOperatorName,
        BeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        EndDate: this.searchData.applyTime ? this.searchData.applyTime[1] : "",
        usertype: 1
      };
      var url = `/iad_customer/ExportGGZ?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${
          filterData[key] || filterData[key] === 0 ? filterData[key] : ""
        }`;
      }
      return url;
    }
  },
  components: {
    // 面包屑
    crumbs,
    // 充值弹框
    rechargeDialog,
    // 退款
    refundDialog
  },
  methods: {
    getUser(queryString, cb) {
      GetUser({ name: queryString, userType: 1 }).then(res => {
        var data = res.list || [];
        if (data.length) {
          cb(data);
        } else {
          cb([{ name: "暂无数据" }]);
        }
      });
    },
    handleSelect(item) {
      if (item.id) {
        this.searchData.UserId = item.id.toString();
      }
    },
    initData() {
      GetUserAdOperatorUser().then(res => {
        this.UserAdOperatorUser = Object.assign(
          {},
          this.UserAdOperatorUser,
          res.list
        );
      });
      GetSalesman().then(res => {
        this.Salesman = Object.assign({}, this.Salesman, res.list);
      });
      GetUserRoleList().then(res => {
        if (res.success) {
          this.UserRoleList = Object.assign({}, this.UserRoleList, res.model);
        }
      });
    },
    getAdvertiserList(type) {
      if (type) {
        this.currentPage = 1;
      }
      let searchData = this.searchData
      var filterData = {
        page: this.currentPage,
        Complete: searchData.Complete,
        IsActive: searchData.IsActive,
        UserId: searchData.UserId,
        UserEmail: searchData.UserEmail,
        SalesmanName: searchData.SalesmanName,
        CompanyName: searchData.CompanyName,
        Status: searchData.Status,
        UserSource: searchData.UserSource,
        AdOperatorName: searchData.AdOperatorName,
        BeginDate: searchData.applyTime
          ? searchData.applyTime[0]
          : "",
        EndDate: searchData.applyTime ? searchData.applyTime[1] : "",
        usertype: 1,
        ParentUserName: searchData.proxyID || ""
      };
      GetAdvertiserList(filterData)
        .then(res => {
          if (res.Items) {
            this.tableData = res.Items;
            this.dataSize = res.TotalNum;
          } else {
            this.tableData = [];
            this.dataSize = 0;
          }
        })
        .catch(err => {
          this.tableData = [];
          this.dataSize = 0;
        });
    },
    setToolTip(row, column, cell, event) {
      var child = cell.children[0];
      if (cell.classList.contains("showToolTip")) {
        if (child.innerText) {
          child.classList.add("el-tooltip");
        } else {
          child.classList.remove("el-tooltip");
        }
      }
    },
    // 充值操作
    recharge(row) {
      this.currentData = row;
      this.showRechargeDialog = true;
    },
    closeRechargeDialog(data) {
      if (data) {
        IadAdrRecharge(data).then(res => {
          if (res.status === 0) {
            this.$message({
              message: res.message,
              type: "success"
            });
          } else {
            let message = "充值操作失败";
            this.$message({
              message: res.message || message,
              type: "warning"
            });
          }

          this.showRechargeDialog = false;
        });
      } else {
        this.showRechargeDialog = false;
      }
    },
    // 退款操作
    refund(row) {
      this.refundInfo = row;
      RefundShow({ UserId: row.UserId }).then(res => {
        if (res.result > 0) {
          this.refundInfo.RechargeAmount = res.model.RechargeAmount.toFixed(2);
          this.refundInfo.RebateAmount = res.model.RebateAmount.toFixed(2);
          this.refundInfo.callback = RefundShowSubmit;
          this.showRefundDialog = true;
        } else {
          this.$message({
            message: StatusInfo(res.result) || "未知错误",
            type: "warning"
          });
        }
      });
    },
    closeRefundDialog() {
      this.showRefundDialog = false;
    },
    // 跳转页面
    goOtherPage(row) {
      let url = `/IAD_Customer/Edit?id=0&userType=1`;
      if (row) {
        url = `/IAD_Customer/Edit?id=${row.UserId}&userType=1`;
      }
      location.href = url;
    },
    // 格式化日期
    formatDater(row, column, cellValue, index) {
      if (cellValue) {
        return formatDateAll(cellValue);
      } else {
        return cellValue;
      }
    },
    // 分页切换页码
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.getAdvertiserList();
    },
    // 审核操作
    auditing(row, type) {
      var checkData = {
        UserId: row.UserId,
        Status: 1
      };
      var message;
      if (type === 1) {
        checkData.Status = 3;
        message = "通过审核成功！";
      } else {
        checkData.Status = 2;
        message = "拒绝审核成功！";
      }
      CheckUser(checkData).then(res => {
        if (res.success) {
          this.$message({
            message: res.message || message,
            type: "success"
          });
          this.getAdvertiserList();
        } else {
          this.$message({
            message: res.message || "审核失败！",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    document.title = "广告主客户";
    this.initData();
    this.getAdvertiserList();
  },
  mounted() {}
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}

ul.nav {
  padding: 0 !important;
}

#navbar .sign-in-wrap {
  padding-right: 50px !important;
}

.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}

#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}

.money-icon {
  margin-right: 5px !important;
}

.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}

.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}

.putonArea .region {
  margin-top: 4px !important;
}

.putonArea .region .provinces-group {
  width: 650px !important;
}

.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}

.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}

.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}

.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";

.advertiser {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-form-item {
      vertical-align: middle;
      .el-form-item__content {
        vertical-align: middle;
        .el-date-editor {
          width: 240px;
        }
        .el-button {
          vertical-align: middle;
          min-width: 94px;
        }

        .export-button {
          vertical-align: middle;
          width: 94px;
          display: inline-block;
          color: #fff;
          background-color: #5798d7;
          line-height: 1;
          white-space: nowrap;
          cursor: pointer;
          border: 1px solid #5798d7;
          text-align: center;
          box-sizing: border-box;
          outline: 0;
          margin-left: 10px;
          padding: 9px 15px;
          font-size: 12px;
          border-radius: 4px;
          &:hover {
            background: #66b1ff;
            border-color: #66b1ff;
            color: #fff;
          }
        }
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
      font-size: 14px;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-table {
      .cell.el-tooltip {
        width: normal;
        min-width: none;
      }
      .el-row {
        .el-col {
          .el-button {
            margin: 0;
            text-align: left;
            font-size: 14px;
          }
          .goOtherPage {
            display: inline-block;
            width: 100%;
            text-align: left;
            font-size: 14px;
            font-weight: 500;
            padding: 9.5px 0;
            border: 1px solid transparent;
            color: #409eff;
            box-sizing: border-box;
          }
        }
      }
      .el-button {
        margin: 0;
        width: 100%;
        font-size: 14px;
        font-weight: 500;
      }
      thead {
        tr {
          background-color: #f5f5f5 !important;
          border-bottom: 2px solid #bbb;
          text-align: center;
        }
      }
    }

    .el-pagination {
      text-align: center;
      margin: 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer-management/Advertiser.vue